import React from 'react';
import { DateTimeService } from 'services/datetime-service';
import { EventFormViewModel } from 'stores/events/event-form-store';
import { EventDto } from 'stores/events/events-store';
import { CountryFlag } from 'widgets/bussiness/country-flag';

interface MobileEventElementContainerProps {
  event: EventFormViewModel; // El signo ? hace que sea opcional
  selectedEvent: EventDto;
  onClick?: (request: EventDto) => void;
}

const MobileEventElementContainer: React.FC<MobileEventElementContainerProps> = ({ event, selectedEvent, onClick }) => {
  const color = event.eventType?.eventsColor || '#ccc';

  // Instructores
  let instructorsText = '';
  if (event.instructors?.length === 1) {
    const i = event.instructors[0];
    instructorsText = [i.user?.firstName, i.user?.lastName].filter(Boolean).join(' ');
  } else if (event.instructors?.length === 2) {
    instructorsText = event.instructors
      .map(i => [i.user?.firstName, i.user?.lastName].filter(Boolean).join(' '))
      .filter(Boolean)
      .join(', ');
  } else if (event.instructors?.length > 2) {
    const names = event.instructors
      .slice(0, 2)
      .map(i => [i.user?.firstName, i.user?.lastName].filter(Boolean).join(' '))
      .filter(Boolean);
    const extraCount = event.instructors.length - 2;
    instructorsText = `${names.join(', ')} .. +${extraCount} instructors`;
  }

  // Fechas
  const startDate = event.startDate ? event.startDate : '';
  const endDate = event.endDate ? event.endDate : '';

  // Localización
  const location = event.eventDetails?.location?.title || '';

  // Status
  const status = event.status || '';

  // Tipo
  const eventType = event.eventType?.name || '';

  return (
    <div
      className="bg-white rounded shadow p-4 border-l-4 cursor-pointer transition hover:shadow-lg"
      style={{ borderColor: color }}
      onClick={() => onClick(selectedEvent)}
    >
      <div className="flex items-center gap-2">
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: color,
            display: 'inline-block'
          }}
        />
        <p className="text-sm text-gray-500">{eventType}</p>
      </div>
      <h4 className="text-black-600 font-semibold">
        {event.friendlyId} - {event.title}
      </h4>
      {/* Fechas */}
      {startDate && endDate && (
        <p className="text-xs text-gray-500 mb-1">
          {DateTimeService.toDateInputString(startDate, 'YYYY-MM-DD')} - {DateTimeService.toDateInputString(endDate, 'YYYY-MM-DD')}
        </p>
      )}
      {/* Instructores */}
      {instructorsText && (
        <p className="text-sm mb-1 flex items-center gap-1">
          <span aria-label="Instructor" role="img">
            <svg
              className="w-[19px] h-[19px] text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.6"
                d="M14.6144 7.19994c.3479.48981.5999 1.15357.5999 1.80006 0 1.6569-1.3432 3-3 3-1.6569 0-3.00004-1.3431-3.00004-3 0-.67539.22319-1.29865.59983-1.80006M6.21426 6v4m0-4 6.00004-3 6 3-6 2-2.40021-.80006M6.21426 6l3.59983 1.19994M6.21426 19.8013v-2.1525c0-1.6825 1.27251-3.3075 2.95093-3.6488l3.04911 2.9345 3-2.9441c1.7026.3193 3 1.9596 3 3.6584v2.1525c0 .6312-.5373 1.1429-1.2 1.1429H7.41426c-.66274 0-1.2-.5117-1.2-1.1429Z"
              />
            </svg>
          </span>{' '}
          {instructorsText}
        </p>
      )}

      {/* Localización */}
      {location && (
        <p className="text-sm mb-1">
          <CountryFlag
            countryName={
              selectedEvent?.eventDetails?.location?.code !== 'XXXX' && selectedEvent?.eventDetails?.location?.code !== 'XXXXX'
                ? selectedEvent.eventDetails?.location?.countryName
                : null
            }
          />
          &nbsp;{selectedEvent.eventDetails?.location?.location}
        </p>
      )}
      {/* Status */}
      <div className="text-sm mb-1">{status && <span className="block">Status: {status}</span>}</div>
    </div>
  );
};

export default MobileEventElementContainer;
